export default "__VITE_ASSET__8271e83a__"